import { formatNumber } from "src/utils/numberFormat";

export const localizeTextWithNumbers = (text, language) => {
  if (text === null || text === undefined) {
    return "";
  }

  const value = String(text);
  if (!value.trim()) {
    return "";
  }

  return value.replace(/-?\d+(\.\d+)?/g, match =>
    formatNumber(Number(match), { useGrouping: false }, language)
  );
};
